export const PACING_QUERY = {
    view: "explore_pacing_v2",
    fieldMap: {
        "vw_dim_lineitem.advertiser__name": "",
        "vw_dim_lineitem.advertiser__id": "",
        "vw_dim_lineitem.campaign__id": "",
        "vw_dim_lineitem.campaign__name": "",
        "vw_dim_lineitem.campaign_start_date": "",
        "vw_dim_lineitem.campaign_end_date": "",
        // Full timestamps alongside the calendar-date fields above — the date
        // fields truncate to midnight, which breaks ACTIVE/COMPLETED math for a
        // same-day flight. See deriveTimeStatus.
        "vw_dim_lineitem.campaign_start_raw": "",
        "vw_dim_lineitem.campaign_end_raw": "",
        "vw_dim_lineitem.product__name": "",
        "vw_dim_lineitem.product__id": "",
        "vw_dim_lineitem.lineitem_end_date": "",
        "vw_dim_lineitem.lineitem__id": "",
        "vw_dim_lineitem.lineitem__name": "",
        "vw_dim_lineitem.lineitem_start_date": "",
        "vw_dim_lineitem.lineitem_start_raw": "",
        "vw_dim_lineitem.lineitem_end_raw": "",
        "vw_dim_lineitem.lineitem_type": "",
        "vw_dim_lineitem.goal_interval": "",
        "vw_dim_lineitem.period_goal": "",
        "vw_dim_lineitem.per_day_goal": "",
        "vw_dim_lineitem.flight_goal": "",
        "vw_dim_lineitem.period_delivered": "",
        "vw_dim_lineitem.period_delivered_impressions": "",
        "vw_dim_lineitem.period_delivered_spend": "",
        "vw_dim_lineitem.period_remaining_impressions": "",
        "vw_dim_lineitem.period_remaining_budget": "",
        "vw_dim_lineitem.station__name": "",
        "vw_dim_lineitem.station__id": "",
        "vw_dim_lineitem.advertiser__iab_category__raw__name": "",
        "vw_dim_lineitem.advertiser__iab_category__raw__code": "",
        "vw_fct_impressions.pacing_status": "",
        "vw_fct_impressions.flight_delivered_impressions": "",
        "vw_fct_impressions.flight_delivered_spend": "",
        "vw_fct_impressions.flight_remaining_impressions": "",
        "vw_fct_impressions.flight_remaining_budget": ""
    },
    pivots: null,
    fill_fields: null,
    filters: {
        "vw_dim_lineitem.campaign__status_name": "READY,PAUSED,CANCELLED",
        "vw_dim_lineitem.lineitem__status_name": "READY,PAUSED,CANCELLED",
        "vw_dim_lineitem.flt_analysis_interval": "7 day"
    },
    filter_expression: null,
    sorts: ["vw_dim_lineitem.campaign__name"],
    limit: "-1",
    column_limit: "50",
    total: null,
    row_total: null,
    subtotals: null,
    visible_ui_sections: null,
    has_table_calculations: false,
    model: "client_analytics",
    dynamic_fields: "[]",
    query_timezone: null,
    can: {
        cost_estimate: true,
        create: true,
        index: true,
        show: true,
        download: true,
        download_unlimited: true,
        edit_custom_fields: false,
        edit_table_calculations: false,
        explore: false,
        generate_drill_links: true,
        render: true,
        run: true,
        see_results: true,
        save: true,
        schedule: true,
        see_aggregate_table_lookml: false,
        see_derived_table_lookml: false,
        see_lookml: false,
        see_sql: false,
        use_custom_fields: true
    }
};
//# sourceMappingURL=query.js.map